import { useMutation } from "react-query";
import useApi from "./useApiRequest";

export const FindSystemConfiguration = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/usuarios/find-one/system-configuration/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        findSystemConfigurationMutation: mutation.mutate,
    };
}